import React from 'react';
import { Container, Typography, Paper, Button, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const theme = useTheme();
  const oppocolor = theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark;

  return (
    <Container sx={{ mt: 4, textAlign: 'center' }}>
      <Paper elevation={3} sx={{ p: 5, borderRadius: 3, backgroundColor: oppocolor }}>
        <Typography variant="h1" gutterBottom sx={{ color: theme.palette.background.default }}>
          404
        </Typography>
        <Typography variant="h4" gutterBottom sx={{ color: theme.palette.background.default }}>
          Oops! Page Not Found
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.background.default, mb: 3 }}>
          The page you are looking for does not exist.
        </Typography>
        <Button 
          variant="contained" 
          component={Link} 
          to="/" 
          sx={{ mt: 2, backgroundColor: theme.palette.background.default, color: theme.palette.primary.main }}
        >
          Go Back Home
        </Button>
      </Paper>
    </Container>
  );
};

export default NotFound;